module.exports = __webpack_public_path__ + "img/select1.fd9ccba9.png";